var contaTot = parseInt($("#contaImages").val());
var conta = 0;
var contaPrecedente = 0;
var sliderFunction;
var image = "";
$(document).ready(function(){
	if($('.home-canvas')[0] != undefined){
		$('.list-slideshow-image img').css('-webkit-transition','none');
		var bg = "";
		if($(window).width()>767){
	
			for(var i = 0;i< contaTot;i++){
				$(".list-slideshow-image .imageSlideShowMobile")[i].classList.remove('active');
			}
			
			$(".list-slideshow-image .imageSlideShow")[0].classList.add('active');
		}
		else{
			for(var i = 0;i< contaTot;i++){
				$(".list-slideshow-image .imageSlideShow")[i].classList.remove('active');
			}
			$(".list-slideshow-image .imageSlideShowMobile")[0].classList.add('active');
	
		}
	
		if(contaTot>1){
			sliderFunction = setInterval('slideshow()',3000);
		}
		
		$(".home-canvas .btn.btn-primary").mouseover(function(){
			if(contaTot>1){
				clearInterval(sliderFunction);
			}
			conta = parseInt($(this)[0].getAttribute("data-index"));
			var image="";
			if($(window).width()>767){
				
				image = $(this)[0].getAttribute("data-src-desktop");
				
			}else{
				image = $(this)[0].getAttribute("data-src-mobile");
				
			}
			
			if(contaTot != 1){
				$(".list-slideshow-image .imageSlideShowCurrency")[0].src = image;
				
				$(".list-slideshow-image .imageSlideShowCurrency")[0].classList.add('active');
				for(var i = 0;i< contaTot;i++){
					$(".list-slideshow-image .imageSlideShowMobile")[i].classList.remove('active');
					$(".list-slideshow-image .imageSlideShow")[i].classList.remove('active');
				}
			}
			else{
				
				if($(window).width()>767 && ($(".list-slideshow-image .imageSlideShow")[0].src != null && !image.indexOf($(".list-slideshow-image .imageSlideShow")[0].src) > -1) ){
					for(var i = 0;i< contaTot;i++){
						$(".list-slideshow-image .imageSlideShowMobile")[i].classList.remove('active');
						$(".list-slideshow-image .imageSlideShow")[i].classList.remove('active');
					}
					$(".list-slideshow-image .imageSlideShowCurrency")[0].src = image;
					
					$(".list-slideshow-image .imageSlideShowCurrency")[0].classList.add('active');
				}
				if($(window).width()<767 && ($(".list-slideshow-image .imageSlideShow")[0].src != null && !image.indexOf($(".list-slideshow-image .imageSlideShow")[0].src) > -1)){
					for(var i = 0;i< contaTot;i++){
						$(".list-slideshow-image .imageSlideShowMobile")[i].classList.remove('active');
						$(".list-slideshow-image .imageSlideShow")[i].classList.remove('active');
					}
					$(".list-slideshow-image .imageSlideShowCurrency")[0].src = image;
					
					$(".list-slideshow-image .imageSlideowCurrency")[0].classList.add('active');
				}
			}
			
	
			
		}).mouseout(function() {
			conta = 0;
			if($(window).width()>767){
				$(".list-slideshow-image .imageSlideShow")[0].classList.add('active');
	
				for(var i = 0;i< contaTot;i++){
					$(".list-slideshow-image .imageSlideShowMobile")[i].classList.remove('active');
				}	
			}
			else{
				for(var i = 0;i< contaTot;i++){
					$(".list-slideshow-image .imageSlideShow")[i].classList.remove('active');
				}
				$(".list-slideshow-image .imageSlideShowMobile")[0].classList.add('active');
			}
			$(".list-slideshow-image .imageSlideShowCurrency")[0].classList.remove('active');
	
			if(contaTot>1){
				sliderFunction = setInterval('slideshow()',3000);
			}
	    }); 
	}
});
function slideshow(){
	var image = "";
	
	if($(window).width()>767){

		for(var i = 0;i< contaTot;i++){
			$(".list-slideshow-image .imageSlideShowMobile")[i].classList.remove('active');
		}
		$(".list-slideshow-image .imageSlideShow")[contaPrecedente].classList.remove('active');
		$(".list-slideshow-image .imageSlideShow")[conta].classList.add('active');
	}
	else{
		for(var i = 0;i< contaTot;i++){
			$(".list-slideshow-image .imageSlideShow")[i].classList.remove('active');
		}
		$(".list-slideshow-image .imageSlideShowMobile")[contaPrecedente].classList.remove('active');
		$(".list-slideshow-image .imageSlideShowMobile")[conta].classList.add('active');
	}

	contaPrecedente = conta;
	conta = conta + 1 ;
	if(conta>=contaTot){
		conta = 0;
	}
}